app.service('autocomplete', function (searchHistory, search, loading, front, modal, cookie, autocompleteInfo, logData, developSearchModeTest, price) {
	var $input;
	var $results;
	var $container;
	var $lastAjax=null;
	var $closeButton;
	var $clearButton;
	var $autocompleteBox;
	var $suggestion;
	var $searchBox;
	var impressionsTimeout = false;
	var searchTimeout = false;
	var testAB;

	var keyCode = {
		up: 38,
		down: 40,
		enter: 13,
		esc: 27
	};
	var options = {
		minInputLength: 3,
		maxInputLength: 64,
		charactersInQueryLimit: 64,
		historyLimit: 2,
		resultsLimit: 8,
		ajaxUrl: '/searchAutocomplete.ltr',
		loadProductsTimeout: 250,
		impressionsTimeout: 1000
	};
	var lastResponse = {};
	var summaryResults = {};
	var linkName = '';

	function copyToInput(el) {
		$input.val(el);
	}
	function nav(e) {
		var activeItem = $('#ac-results .ac-active');
		var item = $('#ac-results .ac-item');

		if(activeItem.length) {
			activeItem.removeClass("ac-active");
			activeItem = (e.type === 'ac:up') ? activeItem.prev(".ac-item") : activeItem.next(".ac-item");
			activeItem.addClass("ac-active");
			copyToInput($(".ac-text", activeItem).text());
		} else {
			activeItem = (e.type === 'ac:up') ? item.last(".ac-item") : item.first(".ac-item");
			activeItem.addClass("ac-active");
			copyToInput($(".ac-text", activeItem).text());
		}
		setActiveCategory(activeItem);
	}
	function setActiveCategory(item) {
		//$("#search-category").val($(item).attr("data-category"));			nie używane w mobile
	}
	function onKeyUp(e) {
		var inp = String.fromCharCode(e.keyCode);
		if(inp != ' ' && $.inArray(e.keyCode, [17,39,37]) == -1) {
			keyTest(e.keyCode);
		}
	}
	function onChoose(target) {
		var obj = {};
		var active = $(target ? target : this);
		var text = active.data("text") || $input.val();
		var url = active.data("url") || "";
		var category = active.data("category") || "";
		obj[text] = { link: url };

		if(text.length > 1){
			searchHistory.add(obj);
		}
		if(!!url) {
			loading.redirect(url);
		} else {
			search.search(text);
		}
		$input.trigger("blur");
	}
	function getActiveCategory() {
		return $.trim($("#search-category").val());
	}
	function onEsc() {

	}
	function onOpen(e) {
		if(!searchHistory.enabled()) {
			searchHistory.init();
		}
		$results.show().addClass("ac-open");
		$autocompleteBox.closest("#search-box").addClass("ac-expanded");
		closeKeyboard();
		var q = e.target.value;
		if(q.length < 3) {
			$input.trigger('ac:inputShort');
		} else {
			$input.trigger('ac:inputLong');
		}
	}
	function closeKeyboard() {
		$(document).trigger("touchstart", function(){
			if(($input).is(":focus")) $input.blur();
		});
	}
	function abort(){
		if($lastAjax!==null){
			$lastAjax.abort();
			$lastAjax=null;
		}
	}
	function onInputShort() {
		var q = $input.val();
		lastResponse = {};
		abort();
		summaryResults = $.extend({}, find(q));
		render();
	}
	function startsWith(str, str2) {
		return str.indexOf(str2) === 0;
	}
	function filterResponse(item) {
		var exist = false;
		$.each(lastResponse, function(name, group){
			$.each(group, function(key, obj) {
				if(this.name === item) {
					exist = true;
				}
			});
		});
		return exist;
	}
	function find(q) {
		var his = searchHistory.get();
		var suggestions = {saved:[]};
		$.each(his, function(i, obj) {
			if(Object.keys(obj).length === 0){
				return false;
			}
			var keyword = Object.keys(obj)[0];
			var keywordLower = keyword.toLowerCase();
			if(startsWith(keywordLower, q.toLowerCase()) && !filterResponse(keywordLower.toLowerCase())) {
				suggestions.saved.push({name: keyword, url: obj[keyword].link});
			}
		});
		suggestions.saved = suggestions.saved.slice(0, options.historyLimit);
		if (suggestions.saved.length) {
			autocompleteInfo.setData({
				type: 'history',
				historyLength: suggestions.saved.length
			});
		}
		return suggestions;
	}
	function onInputLong(e) {
		var q = $input.val();
		if(q.length>2){
			var newLinkName = getLinkName();
			if($.isEmptyObject(lastResponse) || linkName != newLinkName) {
				onQuery(e);
				return;
			}
			summaryResults = $.extend({}, find(q), lastResponse);
			render();
		}
	}
	function getPromotionSuggestion ({ name, link, image }) {
		let testAB = cookie.get('searchTestAB');
		if(testAB === 'G'){
			link = link.replace('/search.bhtml', '/search2.bhtml');
		} else if(testAB === 'P'){
			link = link.replace('/search.bhtml', '/search3.bhtml');
		}
		return `
			<div class="ac-item ac-group-promotion" data-url="${link}" tabindex="0">
				<span class="ac-text">${name}</span>
			</div>
		`;
	}
 	function render() {
		var $tempResults = $results.detach();
		var n = 1;
		clearResults();

		function prepareResultsOld(groups) {
			$.each(groups, function(name, group){
				if (name === 'promotionSuggestion' && group) {
					var promotionSuggestion = getPromotionSuggestion(groups.promotionSuggestion);
					$tempResults.find('.ac-group-categorySuggestions').last().after(promotionSuggestion);
				} else {
					$.each(group, function(j, obj){
						if(n <= options.resultsLimit) {
							$tempResults.append(prepareItem(obj, name, j));
							n++;
						}
					});
				}
			});


			$suggestion.empty();
			$tempResults.find('.ac-group-suggestions').each(function(){
				$(this).appendTo($suggestion);
			});

			if(!$tempResults.find('.ac-group-saved').length && $('.ac-group-suggestions').length) {
				$suggestion.prepend('<p class="ac-title">Popularne hasła</p>');
			} else if($tempResults.find('.ac-group-saved').length) {
				$results.prepend('<p class="ac-title">Ostatnio wyszukiwane</p>');
			}
			if(n === 1) {
				$searchBox.addClass('empty');
				} else {
				$searchBox.removeClass('empty');
				}

			return $tempResults;
		}
		$container.append(prepareResultsOld(summaryResults));
 	}
	function onQuery(e) {
		var q = e.target.value.replace(/[^ąćęłńóśźżĄĆĘŁŃÓŚŹŻ\w\s]/gi, ' ').trim();
		q = q.slice(0, options.charactersInQueryLimit);

		clearTimeout(searchTimeout);
		if(q.length < 3) {
			onInputShort();
			$searchBox.removeClass('search-open searching');
			return;
		}

		searchTimeout = setTimeout(function() {
			searching(e, q);
		}, options.loadProductsTimeout);
	}
	function loadProducts(q){
		if(lastResponse && lastResponse.suggestions && lastResponse.suggestions.length && lastResponse.suggestions[0].name) {
			let res = lastResponse.suggestions[0];
			$.ajax({
				url: '/searchAutocompleteProducts.ltr',
				method: 'GET',
				data: {
					suggestion: res.name,
					linkName: res.linkName || undefined,
					userId: logData.customerId(),
					showRecommendationsFromAWSonMainPage: logData.showRecommendationsFromAWSonMainPage(), // brak funkcjonalnosci dla mobile
					developSearchMode: developSearchModeTest.isEnabled()
				},
				success: function (result) {
					generateTemplate(result.products, res.link, res.categorySufix ? res.name+' '+res.categorySufix : res.name, q);
					$searchBox.removeClass('searching');
				}
			});
			var categorySuggestionsLength = lastResponse.categorySuggestions && lastResponse.categorySuggestions.length ? lastResponse.categorySuggestions && lastResponse.categorySuggestions.length : 0;
			var suggestionsLength = lastResponse.suggestions && lastResponse.suggestions.length ? lastResponse.suggestions.length : 0
			autocompleteInfo.setData({
				count: categorySuggestionsLength + suggestionsLength,
				categoryLength: categorySuggestionsLength,
				suggestionsLength: suggestionsLength,
				category: {
					type: 'suggestions',
					position: 1,
					text: res.name,
					fullText: res.categorySufix ? res.name+res.categorySufix : res.name,
					category: res.categoryName
				}
			});
		}
	}
	var visibleProducts = [];
	function generateTemplate(productList, link, suggestionText, keyword){
		var result = '';
		var productPriceLabel = '';
		var productPriceBox = '';
		productList.forEach((product, i) => {
			if(product.voucherDiscountedPriceAvailable){
				productPriceBox = `
					<div class="product-price price-voucher"> 
						<div class="price-normal">
							${product.voucherDiscountedPrice ? product.voucherDiscountedPrice + "&nbsp;zł" : ""}
						</div>
					</div>
				`
			} else {
				productPriceBox = `
					<div class="product-price ${product.discountedPriceAvailable ? ' discounted-price-available' : ''}"> 
						<div class="price-normal">
							${product.price ? product.price + "&nbsp;zł" : ""}
						</div>
					</div>
				`
			}
			if (product.priceLabelDto && !product.priceLabelDto.labelPhotoPath) { 
				productPriceLabel = `
					<div class="price-promotional-label">
						<div class="price-promotional-label-name">${product.priceLabelDto.labelText}</div>
						<div class="price-promotional-label-discount">${product.priceLabelDto.discountAmount ? '-' + price.format(product.priceLabelDto.discountAmount) : ''}</div>
					</div>
				`;
			} else if (product.priceLabelDto && product.priceLabelDto.labelPhotoPath) {
				productPriceLabel = `
					<div class="price-promotional-label">
						<div class="price-promotional-label-image">
							<img src="${product.priceLabelDto.labelPhotoPath}" alt="Euro Hit Cenowy"/>
						</div>
					</div>
				`;
			} else {
				productPriceLabel = '';
			}
			result += `<a ${product.cardDefaultUrl ? `href="${prepareLink(product.cardDefaultUrl)}"` : ''} class="search-products-item" data-id="${product.id}" data-product-name="${product.name ? product.name : ''}" data-product-category="${product.groupName ? product.groupName : ''}">
				<div class="product-photo">
					${product.photo ? `<img src="${product.photo}" alt="${product.name}"/>` : ''}
					${product.voucherDiscountedPriceAvailable ? `<span class="product-voucher-discount-label">Cena z kodem</span>` : ''}
					${product.discountedPriceAvailable ? `<span class="product-promotion-label">Promocja</span>` : ''}
				</div>
				<div class="product-name">
					${product.name ? product.name : ''}
				</div>
				<div class="product-category">
					${product.groupName ? product.groupName : ""}
				</div>
				<div class="stars-rating">
					<div>
						${product.grade ? `<span style="width:${20*product.grade}%;"></span>` : ''}
					</div>
					${product.grade ? ` <b class="rating-grade">${product.grade}</b>` : ''}
					${product.quantity ? `<em class="rating-count">(${product.quantity})</em>` : ""}</em>
				</div>
				${productPriceLabel}
				${productPriceBox}
			</a>`;
			if(suggestionText && keyword.length>2){
				visibleProducts.push({
					id: product.id,
					plu: product.productInfoCode,
					list: 'Wyszukiwarka/Polecane produkty',
					position: (i+1),
					price: product.productInfoPrice,
					category: product.productInfoGroupName,
					name: product.productInfoName,
					brand: product.productInfoBrandName,
					variant: '',
					status: product.productInfoAvailabilityStatusCode,
					dimension56: keyword,
					dimension59: suggestionText
				});
			}
		});
		if(link){
			const firstProductGroupName = productList[0] && productList[0].groupName ? productList[0].groupName : '';
			result += `<div class="more-products"><a class="more-products-link" href="${prepareLink(link)}" data-product-category="${firstProductGroupName}">Zobacz więcej polecanych produktów</a></div>`;
		}
		$products.html('<p class="search-products-title">Popularne produkty</p><div class="search-products-list">'+result+'</div>');
		var logScroll=true;
		if(suggestionText && keyword.length>2 && productList.length && visibleProducts.length){
			clearTimeout(impressionsTimeout);
			impressionsTimeout = setTimeout(function(){
				var width = $products.width();
				var count = Math.floor(width/155);
				logImpressions(count);
				logScroll=false;
			}, options.impressionsTimeout);
		}
		$('.search-products-list', $products).on('scroll', function(){
			if(!logScroll){
				logScroll=true;
				logImpressions();
			}
		});

	}
	
	var loggedImpressions = [];
	function logImpressions(count=10){
		var result = [];
		if(visibleProducts && visibleProducts.length){
			visibleProducts.forEach((product, i) => {
				if(result.length<=count){
					var isLogged = loggedImpressions.filter(function (item,j){
						return item.id == product.id && item.dimension56 == product.dimension56 && item.dimension59 == product.dimension59;
					});
					if(isLogged.length == 0){
						result.push(product);
						loggedImpressions.push(product);
					}
				}
			});
			if(result.length){
				UA.push({
					'ecommerce': {
						'impressions': result
					}
				});
				UA.push({ 'event': 'productListView' });
			}
		}
	}
	function searching(e, q) {
		linkName = getLinkName();
		$searchBox.addClass('search-open searching');
		abort();
		$lastAjax=$.ajax({
			url: options.ajaxUrl,
			data: {
				keyword: q,
				linkName: linkName || undefined,	//mobilna niekorzysta
				developSearchMode: developSearchModeTest.isEnabled()
			},
			success: function(response) {
				lastResponse = response;
				onInputLong(e);
				render();
				loadProducts(q);
			},
			error: function() {
				lastResponse = {};
			}
		});
	}
	function getLinkName() {
		return $("#search-category").val();
	}
	function onForget(e) {
		e.stopPropagation();
		var text = $(e.target).prev().text();
		var $parent = $(e.target).parent();
		searchHistory.remove(text);
		$parent.remove();
	}
	function onCloseAC(e) {
		$results.hide(0).removeClass("ac-open");
		$autocompleteBox.closest("#search-box").removeClass("ac-expanded");
		clearResults();
	}
	function clearResults() {
		$results.html('');
	}
	function prepareLink(link){
		let testAB = cookie.get('searchTestAB');
		if(link){
			if(testAB === 'G'){
				link = link.replace('/search.bhtml', '/search2.bhtml');
			} else if(testAB === 'P'){
				link = link.replace('/search.bhtml', '/search3.bhtml');
			}
			link += link.indexOf('?') === -1 ? '?' : '&';
			link += 'optimized_search=1';
			return link;
		}
		return false;
	}
	function prepareItem(obj, groupname, position) {
		var val = $input.val();
		val = val.replace(/[^ąćęłńóśźżĄĆĘŁŃÓŚŹŻ\w\s]/gi, ' ').trim();
		var text = obj.name;
		if(val) text = obj.name.replace(new RegExp('(' + val + ')', 'gi'), "<b>$1</b>");
		var group = '';
		if(groupname == "categorySuggestions") {
			group = 'category';
		} else if(groupname == "suggestions") {
			group = 'suggestion';
		} else if(groupname == "saved") {
			group = 'history';
		}
		var $item = $('<div/>', {
			class: 'needsclick ac-item ac-group-' + groupname,
			'data-text': obj.name,
			'data-full-text': obj.categorySufix ? obj.name+' '+obj.categorySufix : obj.name,
			'data-position': position+1,
 			'data-url': prepareLink(obj.link) || prepareLink(obj.url) || prepareLink('/search.bhtml?keyword=' + obj.name),
 			'data-category': obj.categoryName || "0",
			'data-group': group,
			'tabindex': '0',

		});
		var textEl = $("<span/>", {class:"ac-text"}).html(text);
		var textCat = $("<i/>", {text: obj.categorySufix});
		$item.append(textEl);
		if(obj.categorySufix) $item.append(textCat);
		if(groupname === 'saved') {
			$item.append($("<span/>", {
				'class': 'forget',
				role: 'button',
				tabindex: '0',
				text: 'usuń'
			}));
		}
		return $item;
	}
	function stopPropagationContainer(e) {
		e.stopPropagation();
	}
	function highlightOn () {
		$("#ac-results .ac-item").removeClass('ac-active').not(this);
		$(this).addClass('ac-active');
	}
	function closeAndClear() {
		onCloseAC();
		clearInput();
		modal.close();
	}
	function clearInput() {
		$input.val("");
	}
	function setListeners() {
		$(document).on("click", onCloseAC)
			.on('focusin', function(e) {
				// zamknięcie autocompleta po wyjściu tabulatorem z wyszukiwarki
				if(!$(e.target).parents('#search-box').length){
					onCloseAC(e);
				}
			});;
		$input.on('ac:enter', function(){
			autocompleteInfo.logData({
				type: 'enter'
			});
			onChoose();
		});
		$input.on('ac:esc', onEsc);
		$input.on('keyup', onKeyUp);
		if(testAB !== 'P'){
			$input.on('ac:query', onQuery);
			$input.on('focus', onOpen);
			$input.on('ac:up ac:down', nav);
			$input.on('ac:inputShort', onInputShort);
			$input.on('ac:inputLong', onInputLong);
		}
		$container.on("click", stopPropagationContainer);
		$results.on("mouseenter mouseleave",".ac-item", highlightOn);
		$results.on('keydown', '.ac-item', function(e) {
			if(e.keyCode == 13 || e.keyCode == 32) {
				e.preventDefault();
				onChoose(e.target);
			}
		});
		$results.on("click",".ac-item", function(){			// wyniki w lewej kolumnie
			var $this = $(this);
			autocompleteInfo.logData({
				type: $this.data('group'),
				category:{
					position: $this.data('position'),
					text: $this.data('text'),
					fullText: $this.data('full-text'),
					id: $this.data('category')
				},
				redirectLink: $(this).attr('data-url')
			});
			onChoose(this);
		});
		$('#ac-search-products').on("click",".search-products-item", function(){			// produkty 
			var $this = $(this);
			autocompleteInfo.logData({
				type: 'product',
				count: visibleProducts.length,
				product: visibleProducts.filter(function(item){return item.id == $this.data('id')})[0],
				productName: $this.data('product-name').trim(),
				redirectLink: $this.attr('href')
			});
		})

		$suggestion.on('keydown', '.ac-item', function(e) {
			if(e.keyCode == 13 || e.keyCode == 32) {
				e.preventDefault();
				onChoose(e.target);
			}
		}).on("click",".ac-item", function(){			// wyniki w lewej kolumnie
			var $this = $(this);
			autocompleteInfo.logData({
				type: $this.data('group'),
				category:{
					position: $this.data('position'),
					text: $this.data('text'),
					fullText: $this.data('full-text'),
					id: $this.data('category')
				},
				redirectLink: $this.attr('data-url')
			});
		}).on("click", ".ac-item", onChoose);

		$results.on('keydown', '.forget', function(e){
			if(e.keyCode == 13 || e.keyCode == 32) {
				onForget(e);
			}
		}).on('click', '.forget', onForget);

		$closeButton.on('keydown', function(e){
			if(e.keyCode == 13 || e.keyCode == 32) {
				e.preventDefault();
				closeAndClear();
			}
		}).on('click', closeAndClear);

		$clearButton.on('keydown', function(e){
			if(e.keyCode == 13 || e.keyCode == 32) {
				e.preventDefault();
				clearInput();
				$input.focus();
			}
		}).on('click', function() {
			clearInput();
			$input.focus();
		});
	}

	function keyTest(k) {
		switch (k) {
			case keyCode.up:
				$input.trigger('ac:up');
				break;
			case keyCode.down:
				$input.trigger('ac:down');
				break;
			case keyCode.enter:
				$input.trigger('ac:enter');
				break;
			case keyCode.esc:
				$input.trigger('ac:esc');
				break;
			default:
				$input.trigger('ac:query');
		}
	}
	function init() {
		testAB = cookie.get('searchTestAB');
		$searchBox = $('#search-box');
		$input = $("#keyword");
		$suggestion = $('#ac-suggestion');
		$products = $('#ac-search-products');
		$results = $('#ac-results');
		$clearButton = $(".js-search-clear");
		$closeButton = $(".ac-close-results");
		$container = $('.ac-container');
		$resultsItem = $("#ac-results .ac-item");
		$autocompleteBox = $(".autocomplete-box");
		options.historyLimit = front.getParam('autocomplete.historySuggestions');
		options.resultsLimit = front.getParam('autocomplete.maxSuggestions');
		options.charactersInQueryLimit = front.getParam('autocomplete.charactersInQueryLimit');
		options.loadProductsTimeout = front.getParam('autocomplete.loadProductsTimeout');
		if(testAB !== 'P'){
			generateTemplate([{},{},{},{},{}], false, false);
		}
		setListeners();
	}

	return {
		init: init
	};
});
